export default __webpack_public_path__ + "static/fuel-special-offer-card-desktop-28acc1fe5bd61411de26fa9b46e2ae71.png";